import { ErrorBoundary } from "@sentry/react";
import posthog from "posthog-js";
import { useEffect, useRef } from "react";
import { GeneralError } from "../components";
import { Layout } from "../containers/layout";
import { PurchaseForm } from "../containers/purchase-form";

const HomePage = () => {
  const countryInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    posthog.capture("eSIM: Homepage Viewed");
  }, []);

  const handleScrollToPurchase = () => {
    const countryInputEl = countryInputRef?.current;

    if (!countryInputEl) {
      return;
    }

    countryInputEl.focus();
  };

  return (
    <Layout onPurchase={handleScrollToPurchase}>
      <ErrorBoundary
        fallback={
          <GeneralError className="rounded-md bg-black/70 px-14 pb-16 pt-12 text-white" />
        }
      >
        <PurchaseForm countryInputRef={countryInputRef} />
      </ErrorBoundary>
    </Layout>
  );
};

export default HomePage;
